const locales = {
  FR_CA: "fr-ca",
  HI_IN: "hi-in",
}

// These locales have no entries of their own in Craft: their pages are the
// English entries below, so lookups by URI have to use the English one.
export const localeAliases = {
  [locales.FR_CA]: "en-ca",
  [locales.HI_IN]: "en-in",
}

export default locales
